<template>
  <div>
    <el-button type="primary" @click="dialogVisible = true"
      >武侠基本配置</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="创建门派"
      width="1000px"
      @close="closeDialog"
      @open="onOpen"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="250px">
        <el-form-item label="最大小数位">
          <el-input-number
            :step="1"
            v-model="detail.precision"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最小锁仓数">
          <el-input-number v-model="detail.minAmount"></el-input-number>
        </el-form-item>
        <el-form-item label="结算最小有效小时数">
          <el-input-number v-model="detail.unitHour"></el-input-number>
        </el-form-item>
          <el-form-item label="自动发放利息月化率">
          <el-input type="number" v-model="detail.annualizedRateForReward">
            <span
              slot="append"
              v-if="detail.annualizedRateForReward"
            >{{ math.multiply(detail.annualizedRateForReward ,100)}} %</span>
          </el-input>
        </el-form-item>
        <el-form-item label="自动发放奖励月化率">
          <el-input type="number" v-model="detail.annualizedRate">
            <span
              slot="append"
              v-if="detail.annualizedRate"
            >{{ math.multiply(detail.annualizedRate ,100)}} %</span>
          </el-input>
        </el-form-item>
        <el-form-item label="推荐人奖励比例">
          <el-input type="number" v-model="detail.inviteProfitRate">
            <span slot="append" v-if="detail.inviteProfitRate"
              >{{ math.multiply(detail.inviteProfitRate, 100) }} %</span
            >
          </el-input>
        </el-form-item>
        <el-form-item label="掌门奖励比例">
          <el-input type="number" v-model="detail.ownerProfitRate">
            <span slot="append" v-if="detail.ownerProfitRate"
              >{{ math.multiply(detail.ownerProfitRate, 100) }} %</span
            >
          </el-input>
        </el-form-item>
        <el-form-item label="直接邀请人排行比例">
          <el-input
            v-model="detail.rankingRates"
            placeholder="各排名大分红比例用逗号(英文)隔开， 如: 0.05,0.13,0.45"
          >
            <span slot="append" v-if="detail.bonusRate">{{
              detail.rankingRates &&
                detail.rankingRates
                  .split(',')
                  .map(item => math.multiply(item, 100) + ' %')
                  .join(' | ')
            }}</span>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
import math from 'common/math';

export default {
  name: 'leagueCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        annualizedRate: { required: true, message: '请填写' },
        bonusRate: { required: true, message: '请填写' },
        rankingRates: { required: true, message: '请填写' },
        inviteProfitRate: { required: true, message: '请填写' },
        ownerProfitRate: { required: true, message: '请填写' },
        unitHour: { required: true, message: '请填写' },
        minAmount: { required: true, message: '请填写' },
        precision: { required: true, message: '请填写' }
      },
      math
    };
  },
  components: {
    Editor,
    Upload
  },
  methods: {
    ...mapActions('league', ['getConfig', 'updateConfig']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.updateConfig({
        ...this.detail,
        rankingRates:
          this.detail.rankingRates && this.detail.rankingRates.split(',')
      }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh', {
          page: 1
        });
      });
    },
    onOpen() {
      this.getData();
    },
    getData() {
      this.getConfig().then(res => {
        this.detail =
          (res.data && {
            ...res.data,
            rankingRates: res.data.rankingRates.join(',')
          }) ||
          {};
      });
    },
    mounted() {
      this.getData();
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
